package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.data.VerseEntity

class GetTableRowsUseCase {

    operator fun invoke(verseEntities: List<VerseEntity>, startNumber: Int = 1): String =
        verseEntities.withIndex().joinToString(separator = "") {
            val number = startNumber + it.index
            val verseEntity = it.value
            buildString {
                append(
                    """
                    <tr>
                        <td class="center small checkbox">
                            □
                        </td>
                        <td class="center small">
                            $number
                        </td>
                        <td class="reysha">
                            ${verseEntity.strReysah}
                        </td>
                        <td class="seyfa">
                            ${verseEntity.strSeyfa}
                        </td>
                    """
                )
                verseEntity.strExtraData?.let { data ->
                    append(
                        """
                            <td class="center small">
                                $data
                            </td>
                        """
                    )
                }
                append(
                    """
                        <td class="center small">
                            ${verseEntity.strChapter}
                        </td>
                        <td class="center small">
                            ${verseEntity.strVerse}
                        </td>
                    </tr>
                    """
                )
            }
        }

}
